var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "gtpModal",
        size: "xl",
        "content-class": "menu-bg-blue-transparent-modal gtp-track-modal",
        title: "Ground Truth Point Tracking",
        "hide-footer": "",
        scrollable: "",
      },
    },
    [
      _c(
        "div",
        { staticClass: "float-right" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("fa", {
                    attrs: {
                      icon: ["fas", "long-arrow-alt-up"],
                      color: "yellow",
                      title: "Medium Priority",
                    },
                  }),
                  _vm._v(" - Collected between 9 and 12 months ago.\n      "),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("fa", {
                    attrs: {
                      icon: ["fas", "long-arrow-alt-up"],
                      color: "red",
                      title: "Higher Priority",
                    },
                  }),
                  _vm._v(" - Collected more than one year ago.\n      "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("vue-bootstrap4-table", {
        attrs: {
          rows: _vm.gtpRows,
          columns: _vm.gtpColumns,
          config: _vm.config,
          classes: _vm.classes,
        },
        scopedSlots: _vm._u([
          {
            key: "expand",
            fn: function (props) {
              return [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "info" },
                    on: {
                      click: function ($event) {
                        return _vm.getGTPSurvey(props.row.survey_id)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      [
                        _c("fa", {
                          attrs: {
                            icon: ["fas", "info-circle"],
                            title: "Details",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "variant",
            fn: function (props) {
              return [
                props.row.variant == "2"
                  ? _c(
                      "span",
                      [
                        _c("fa", {
                          attrs: {
                            icon: ["fas", "long-arrow-alt-up"],
                            color: "red",
                            size: "1x",
                            title: "Higher Priority",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                props.row.variant == "1"
                  ? _c(
                      "span",
                      [
                        _c("fa", {
                          attrs: {
                            icon: ["fas", "long-arrow-alt-up"],
                            color: "yellow",
                            size: "1x",
                            title: "Medium Priority",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }